import * as ko from "knockout";
import { Api } from "../../app-api";
import { App } from "../../app";

export class CreditCard {

    cvv = ko.observable<string>();
    expiry = ko.observable<string>();
    number = ko.observable<string>();
    getToken = ko.observable(false);

    json: () => any;

    constructor() {
        let self = this;

        self.json = () => {
            return self.toJson();
        }
    }

    private toJson() {
        let self = this;

        return {
            number: self.number(),
            expiry: self.expiry(),
            cvv: self.cvv(),
            getToken: self.getToken()
        }
    }
}

export class PromoCode {
    name = ko.observable("");
    discount = ko.observable<number>();
    discountdisplay = ko.observable("");
    percentage = ko.observable<boolean>();
    invalid = ko.observable(false);
    show = ko.observable(false);

    dirty: ko.PureComputed<boolean>;
    status: ko.PureComputed<string>;
    valid: ko.PureComputed<boolean>;

    submit: () => void;
    toggleShow: () => void;

    constructor(data: any, busy: ko.Observable<boolean>) {
        let self = this;

        //console.log(data);

        if (!App.empty(data)) {
            self.name(data.name);
            self.discount(data.discount);
            self.percentage(data.percentage);
            self.discountdisplay(self.percentage() ? self.discount().toString() + " %" : "$ " + self.discount().toString());
        }
        else {
            data = { name: "" }
        }

        self.dirty = ko.pureComputed(() => {
            return data.name !== self.name();
        }, self);

        self.valid = ko.pureComputed(() => {
            return self.dirty() ? false : (App.hasVal(self.discount()) && self.discount() > 0);
        }, self);

        self.status = ko.pureComputed(() => {
            if (self.valid()) { return "is-valid"; }
            if (self.invalid()) { return "is-invalid"; }
        }, self);

        self.toggleShow = () => {
            self.show(!self.show());
        }

        self.submit = () => {
            if (!busy() && self.dirty())
              self.validate(busy);
            if (self.invalid() && !self.dirty() && data.name === "") 
                self.invalid(false);
        }

        if (self.valid()) {
            self.invalid(false);
            self.show(true);
        }
    }

    private toJson() {
        let self = this;

        return {
            code: self.name()
        }
    }

    private validate(busy: ko.Observable<boolean>) {
        let self = this;

        busy(true);

        self.invalid(false);

        const data = self.toJson();

        Api.PromoCode(data)
            .done(results => {
                if (results.error) { return App.alertError(results.message); }
                if (!App.isValid(results.valid)) { self.invalid(true); return; }
                window.location.reload();
            })
            .always(() => busy(false));
    }
}

